// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__3Tc3V","title":"ClientCherryInfo_title__2J0Bf","itemText":"ClientCherryInfo_itemText__1TMtL"};